export default "__VITE_ASSET__Cclzm2zQ__"